import { typePosConfigurationFilters } from "./dPosConfigurationReducer";
import { typeEditProductsItemObject } from "components/containers/dashboard/dataProducts/popupContents/popupEdit";
import { typeAddPosConfigurationItemObject } from "components/containers/dashboard/dataPosConfiguration/popupContents/popupAdd";
import { typeEditPosConfigurationItemObject } from "components/containers/dashboard/dataPosConfiguration/popupContents/popupEdit";
import { apiClient } from "model/axiosConfig";

// Type
export type typePosConfigurationRequestFilters = {
  filters: {
    name?: string | string[] | null;
    storeIds?: {
      in: string[];
    } | null;
    posIds?: {
      in: string[];
    } | null;
  };
  sortFilter?: {
    direction: string;
    column: string;
  };
};

// Get configuration list
export const getPosConfigurationList = async (payload: {
  filters: typePosConfigurationFilters;
}) => {
  const path = "/pos/configuration/search";
  const config = {
    headers: {},
  };
  const data: typePosConfigurationRequestFilters = {
    filters: {},
    sortFilter: {
      direction: "ASC",
      column: "name",
    },
  };

  if (payload.filters.name) data.filters.name! = [payload.filters.name];
  if (payload.filters.storeId)
    data.filters.storeIds! = { in: [payload.filters.storeId] };
  if (payload.filters.posId)
    data.filters.posIds! = { in: [payload.filters.posId] };

  try {
    return await apiClient.post(path, data, config);
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

// Get configuration item
export const getPosConfigurationItem = async (payload: { itemId: string }) => {
  const path = "/product/product/" + payload.itemId;
  const config = {
    headers: {},
  };

  try {
    return await apiClient.get(path, config);
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

// Get POS full item
export const getPosFullItem = async (payload: { itemId: string }) => {
  const path = `/pos/configuration/${payload.itemId}/full`;
  const config = {
    headers: {},
  };

  try {
    return await apiClient.get(path, config);
  } catch (error) {
    return error.response;
  }
};

// Get POS list
export const getPosList = async () => {
  const path = `/product/pos`;
  const config = {
    headers: {},
  };

  try {
    return await apiClient.get(path, config);
  } catch (error) {
    return error.response;
  }
};

// Get product list by Ids
export const getProductListByIds = async (payload: {
  ids: string[] | undefined;
}) => {
  const path = `/product/product/bulk?ids=${
    payload.ids ? payload.ids.join(",") : ""
  }`;
  const config = {
    headers: {},
  };

  try {
    return await apiClient.get(path, config);
  } catch (error) {
    return error.response;
  }
};

// Get locked store list
export const getLockStoreList = async () => {
  const path = `/pos/configuration/assigned/store`;
  const config = {
    headers: {},
  };

  try {
    return await apiClient.get(path, config);
  } catch (error) {
    return error.response;
  }
};

// Get locked pos list
export const getLockPOSList = async () => {
  const path = `/pos/configuration/assigned/pos`;
  const config = {
    headers: {},
  };

  try {
    return await apiClient.get(path, config);
  } catch (error) {
    return error.response;
  }
};

// Get product item by id
export const getPosConfigurationItemById = async (payload: {
  itemId: string;
}) => {
  const path = `/product/product/exists/id/?id=${payload.itemId}`;
  const config = {
    headers: {},
  };

  try {
    return await apiClient.get(path, config);
  } catch (error) {
    return error.response;
  }
};

// Get configuration item by Name
export const getPosConfigurationItemByName = async (payload: {
  itemName: string;
}) => {
  const path = `/pos/configuration/exists/name?name=${encodeURI(
    payload.itemName
  )}`;
  const config = {
    headers: {},
  };

  try {
    return await apiClient.get(path, config);
  } catch (error) {
    return error.response;
  }
};

// Set product item
export const changePosConfigurationItem = async (payload: {
  itemObject: typeEditProductsItemObject;
}) => {
  const path = "/product/product";
  const config = {
    headers: {},
  };
  const data = payload.itemObject;

  try {
    return await apiClient.patch(path, data, config);
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

// Add configuration item
export const addPosConfigurationItem = async (payload: {
  itemObject: typeAddPosConfigurationItemObject;
}) => {
  const path = "/pos/configuration";
  const config = {
    headers: {},
  };
  const data = payload.itemObject;

  try {
    return await apiClient.post(path, data, config);
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

// Edit configuration item
export const editPosConfigurationItem = async (payload: {
  itemObject: typeEditPosConfigurationItemObject;
}) => {
  const path = "/pos/configuration";
  const config = {
    headers: {},
  };
  const data = payload.itemObject;

  try {
    return await apiClient.patch(path, data, config);
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

// Delete configuration item
export const deletePosConfigurationItem = async (payload: {
  itemId: string;
}) => {
  const path = `/pos/configuration/${payload.itemId}`;
  const config = {
    headers: {},
  };
  try {
    return await apiClient.delete(path, config);
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

// Get product list slim
export const getProductListSlim = async (payload: { categoryId: string }) => {
  const path = "/product/product/v2/search";
  const config = {
    headers: {},
  };
  const data = {
    filters: {
      category: {
        id: payload.categoryId,
      },
      deleted: false,
    },
    sortFilter: {
      direction: "ASC",
      column: "name",
    },
  };

  try {
    return await apiClient.post(path, data, config);
  } catch (error) {
    return error.response;
  }
};

// Get product list slim
export const getStoresListSlim = async () => {
  const path = "/product/store/search/slim";
  const config = {
    headers: {},
  };
  const data = {
    filters: {
      deleted: false,
    },
    sortFilter: {
      direction: "ASC",
      column: "name",
    },
  };

  try {
    return await apiClient.post(path, data, config);
  } catch (error) {
    return error.response;
  }
};
